import React from 'react'


const Rewind = (props) =>
    <svg {...props}
         viewBox="0 0 32 32"
         xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
        <path

            d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16c0 7.719 6.28 14 14 14s14-6.281 14-14c0-7.72-6.28-14-14-14zm6.472 20.882a1 1 0 0 1-1.027-.05L17 19.869V22a1.002 1.002 0 0 1-1.555.832l-9-6a1 1 0 0 1 0-1.664l9-6A1 1 0 0 1 17 10v2.131l4.445-2.963A1 1 0 0 1 23 10v12c0 .369-.203.707-.528.882zM21 11.869l-4.445 2.963A1 1 0 0 1 15 14v-2.131L8.803 16 15 20.131V18a1 1 0 0 1 1.555-.832L21 20.131v-8.262z"
            fillRule="evenodd"/>
    </svg>

export default Rewind


// WEBPACK FOOTER //
// ./src/components/_common/_icons/Rewind.js